export default {
  //Controls
  fetching: true,
  loading: true,
  isLogged: false,

  //User data
  userName: "",
  token: "",
  phone: "",
  email: "",
  permissions: [],

  //Response
  isSucceeded: null,
  resultMessage: "",
  erroCode: 0,
  errorMessage: "",
  validationErrors: [],
};
